import cx from 'classnames';
import styles from '../HardwarePayment/HardwarePayment.scss';

import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Tooltip from '@material-ui/core/Tooltip';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { useCart } from 'src/components/Cart/UseCart';
import { Image } from 'src/components/Image/Image';
import { TextV2 } from 'src/components/TextV2/TextV2';
import infoIcon from 'src/images/icons/info.svg';
import { useTax } from '../useTax/useTax';

export const TaxSection: React.FC = () => {
  const { t } = useTranslation();
  const { checkout } = useCart();
  const [isTaxTooltip, setTaxTooltip] = useState<boolean>(false);
  const { isTaxSet, taxPrice } = useTax();

  if (!isTaxSet) return null;

  return (
    <div className={cx(styles.container, styles.containerBordered)} data-test="tax-section">
      <div className={cx(styles.containerHeading, styles.containerLabel)}>
        <TextV2
          variant="body"
          tagName="p"
          value={t('order-summary.tax-heading')}
          data-test="tax-heading"
        />
        <ClickAwayListener onClickAway={() => setTaxTooltip(false)}>
          <Tooltip
            title={t('order-summary.tax-description', { price: checkout.subtotal })}
            open={isTaxTooltip}
            placement="top"
            arrow
            classes={{ popper: styles.tooltip }}
            data-test="tax-tooltip"
          >
            <Image
              src={infoIcon}
              alt={t('info')}
              className={cx(styles.containerIcon, styles.containerIconBottom)}
              onClick={() => setTaxTooltip(!isTaxTooltip)}
              data-test="tax-info-icon"
            />
          </Tooltip>
        </ClickAwayListener>
      </div>
      <TextV2
        variant="body"
        tagName="p"
        value={t('order-summary.price', { price: taxPrice })}
        data-test="tax-value"
      />
    </div>
  );
};

TaxSection.displayName = 'TaxSection';
